import React from 'react';
import { AUTH_PREFIX_PATH, APP_PREFIX_PATH } from 'configs/AppConfig';
import CryptoJS from 'crypto-js'

const encryptedModules = localStorage.getItem('modulePermissions');
let modulePermissions;
if (encryptedModules) {
	const bytes = CryptoJS.AES.decrypt(encryptedModules, process.env.REACT_APP_MODULE_ENCRYPTION_KEY);
	const decryptedState = bytes.toString(CryptoJS.enc.Utf8);
	modulePermissions = JSON.parse(decryptedState);
} else {
	modulePermissions = undefined;
}

export const publicRoutes = [
	{
		key: 'login',
		path: `${AUTH_PREFIX_PATH}/login`,
		component: React.lazy(() =>
			import('views/auth-views/authentication/login')
		),
	},
	{
		key: 'login-1',
		path: `${AUTH_PREFIX_PATH}/login-1`,
		component: React.lazy(() =>
			import('views/auth-views/authentication/login-1')
		),
	},
	{
		key: 'two-factor',
		path: `${AUTH_PREFIX_PATH}/two-factor`,
		component: React.lazy(() => import('views/auth-views/authentication/two-factor')),
	},
	{
		key: 'register-1',
		path: `${AUTH_PREFIX_PATH}/register-1`,
		component: React.lazy(() =>
			import('views/auth-views/authentication/register-1')
		),
	},
	{
		key: 'forgot-password',
		path: `${AUTH_PREFIX_PATH}/forgot-password`,
		component: React.lazy(() =>
			import('views/auth-views/authentication/forgot-password')
		),
	},
	{
		key: 'request-demo',
		path: `${AUTH_PREFIX_PATH}/request-demo`,
		component: React.lazy(() =>
			import('views/auth-views/authentication/request-demo')
		),
	},
	{
		key: 'first-login',
		path: `${AUTH_PREFIX_PATH}/first-login`,
		component: React.lazy(() =>
			import('views/auth-views/authentication/first-login')
		),
	},
	{
		key: 'ap-login',
		path: `${AUTH_PREFIX_PATH}/ap-login`,
		component: React.lazy(() =>
			import('views/auth-views/authentication/panel-login')
		),
	},
	{
		key: 'oauth-callback',
		path: `${AUTH_PREFIX_PATH}/oauth-callback`,
		component: React.lazy(() =>
			import('views/auth-views/authentication/oauth-callback')
		),
	},
	{
		key: 'third-party-login',
		path: `${AUTH_PREFIX_PATH}/third-party-login`,
		component: React.lazy(() =>
			import('views/auth-views/authentication/login-1')
		),
	},
	{
		key: 'third-party-two-factor',
		path: `${AUTH_PREFIX_PATH}/third-party-two-factor`,
		component: React.lazy(() => import('views/auth-views/authentication/two-factor')),
	},
];

export const thirdPartyProtectedRoutes = [
	{
		key: 'third-party-terms',
		path: `/third-party-terms`,
		component: React.lazy(() =>
			import('views/app-views/third-party-portal/terms')
		),
		meta: { blankLayout: true },
	},
	{
		key: 'third-party-report',
		path: `/third-party-report`,
		component: React.lazy(() =>
			import('views/app-views/third-party-portal/report')
		),
		meta: { blankLayout: true },
	},
];

export const protectedRoutes = [
	...(modulePermissions?.includes("DASHBOARD") ? [{
		key: 'dashboard.default',
		path: `${APP_PREFIX_PATH}/dashboards/default`,
		component: React.lazy(() => import('views/app-views/dashboards/default')),
	}] : []),
	...(modulePermissions?.includes("DIGITAL_ASSETS") ? [{
		key: 'my-assets',
		path: `${APP_PREFIX_PATH}/dashboards/my-assets`,
		component: React.lazy(() =>
			import('views/app-views/dashboards/my-assets')
		),
	}] : []),
	...(modulePermissions?.includes("DIGITAL_ASSETS") ? [{
		key: 'my-assets-details',
		path: `${APP_PREFIX_PATH}/dashboards/my-assets/details/:id`,
		component: React.lazy(() =>
			import('views/app-views/dashboards/my-assets/details')
		),
	}] : []),
	...(modulePermissions?.includes("DIGITAL_ASSETS") ? [{
		key: 'my-assets-issues-detail',
		path: `${APP_PREFIX_PATH}/dashboards/my-assets/issues/detail/:id`,
		component: React.lazy(() =>
			import('views/app-views/dashboards/issues-detail')
		),
	}] : []),
	// {
	// 	key: 'dashboards-query-network',
	// 	path: `${APP_PREFIX_PATH}/dashboards/domain/query-network`,
	// 	component: React.lazy(() =>
	// 		import('views/app-views/dashboards/query-network')
	// 	),
	// },
	// {
	// 	key: 'dashboards-query-details',
	// 	path: `${APP_PREFIX_PATH}/dashboards/query-details/:id`,
	// 	component: React.lazy(() =>
	// 		import('views/app-views/dashboards/query-details')
	// 	),
	// },
	...(modulePermissions?.includes("SCAN_HISTORY") ? [{
		key: 'dashboards-asset-history',
		path: `${APP_PREFIX_PATH}/dashboards/asset/asset-history`,
		component: React.lazy(() =>
			import('views/app-views/dashboards/asset-history')
		),
	}] : []),
	...(modulePermissions?.includes("SCAN_HISTORY") ? [{
		key: 'dashboards-selected-asset-history',
		path: `${APP_PREFIX_PATH}/dashboards/asset-history/:id`,
		component: React.lazy(() =>
			import('views/app-views/dashboards/asset-history-selected')
		),
	}] : []),
	...(modulePermissions?.includes("AUDIT_LOGS") ? [{
		key: 'dashboards-audit-logs',
		path: `${APP_PREFIX_PATH}/dashboards/audit-logs`,
		component: React.lazy(() =>
			import('views/app-views/dashboards/audit-logs')
		),
	}] : []),
	...(modulePermissions?.includes("SCAN_COMPARISON") ? [{
		key: 'dashboards-asset-comparison',
		path: `${APP_PREFIX_PATH}/dashboards/asset/comparison`,
		component: React.lazy(() =>
			import('views/app-views/dashboards/asset-comparison')
		),
	}] : []),
	...(modulePermissions?.includes("TRUSTSCORE") ? [{
		key: 'cylanatrustscore',
		path: `${APP_PREFIX_PATH}/dashboards/cylanatrustscore`,
		component: React.lazy(() =>
			import('views/app-views/dashboards/cylanatrustscore')
		),
	}] : []),
	...(modulePermissions?.includes("TRUSTSCORE") ? [{
		key: 'create-action-plan',
		path: `${APP_PREFIX_PATH}/dashboards/cylanatrustscore/create-action-plan`,
		component: React.lazy(() =>
			import('views/app-views/dashboards/cylanatrustscore/create-action-plan')
		),
	}] : []),
	...(modulePermissions?.includes("TRUSTSCORE") ? [{
		key: 'thirdpartyassessment',
		path: `${APP_PREFIX_PATH}/dashboards/cylanatrustscore/thirdpartyassessment`,
		component: React.lazy(() =>
			import('views/app-views/dashboards/cylanatrustscore/thirdpartyassessment')
		),
	}] : []),
	// {
	// 	key: 'dashboards-scan-comparison',
	// 	path: `${APP_PREFIX_PATH}/dashboards/scan/scan-comparison`,
	// 	component: React.lazy(() =>
	// 		import('views/app-views/dashboards/scanComparison')
	// 	),
	// },
	...(modulePermissions?.includes("CERTIFICATES") ? [{
		key: 'dashboards-ssl-certificates',
		path: `${APP_PREFIX_PATH}/dashboards/ssl/ssl-certificates`,
		component: React.lazy(() =>
			import('views/app-views/dashboards/ssl')
		),
	}] : []),
	...(modulePermissions?.includes("TECHNOLOGIES") ? [{
		key: 'dashboards-technologies-technology',
		path: `${APP_PREFIX_PATH}/dashboards/technologies`,
		component: React.lazy(() =>
			import('views/app-views/dashboards/technologies')
		),
	}] : []),
	// ...(modulePermissions?.includes("SEARCH") ? [{
	// 	key: 'dashboards-search',
	// 	path: `${APP_PREFIX_PATH}/dashboards/cve/search`,
	// 	component: React.lazy(() =>
	// 		import('views/app-views/dashboards/cve-search')
	// 	),
	// }]: []),
	// ...(modulePermissions?.includes("BROWSE") ? [{
	// 	key: 'dashboards-ssl-browse',
	// 	path: `${APP_PREFIX_PATH}/dashboards/browse`,
	// 	component: React.lazy(() =>
	// 		import('views/app-views/dashboards/browse')
	// 	),
	// }]: []),
	...(modulePermissions?.includes("OSINT") ? [{
		key: 'dashboards-osint',
		path: `${APP_PREFIX_PATH}/dashboards/osint`,
		component: React.lazy(() =>
			import('views/app-views/dashboards/osint')
		),
	}] : []),
	...(modulePermissions?.includes("OSINT") ? [{
		key: 'dashboards-osint-domainscans-eventresult',
		path: `${APP_PREFIX_PATH}/dashboards/osint/domainscans/eventresults/:name/:id/:event`,
		component: React.lazy(() =>
			import('views/app-views/dashboards/domainEventResults')
		),
	}] : []),
	...(modulePermissions?.includes("OSINT") ? [{
		key: 'dashboards-osint-domainscans-scansummary',
		path: `${APP_PREFIX_PATH}/dashboards/osint/domainscans/scansummary/:name/:id`,
		component: React.lazy(() =>
			import('views/app-views/dashboards/domainScansSummary')
		),
	}] : []),
	// {
	// 	key: 'dashboards-reports-executiveSummaryReports',
	// 	path: `${APP_PREFIX_PATH}/dashboards/reports/executiveSummaryReports`,
	// 	component: React.lazy(() =>
	// 		import('views/app-views/dashboards/executiveSummaryReports')
	// 	),
	// },
	// ...(modulePermissions?.includes("SERVICES") ? [{
	// 	key: 'dashboards-port-services',
	// 	path: `${APP_PREFIX_PATH}/dashboards/port-services`,
	// 	component: React.lazy(() =>
	// 		import('views/app-views/dashboards/port-services')
	// 	),
	// }]: []),
	// ...(modulePermissions?.includes("INSTANT_LOOKUP") ? [{
	// 	key: 'dashboards-instant',
	// 	path: `${APP_PREFIX_PATH}/dashboards/instant`,
	// 	component: React.lazy(() =>
	// 		import('views/app-views/dashboards/instant')
	// 	),
	// }] : []),
	...(modulePermissions?.includes("ALL_VULNERABILITIES") ? [{
		key: 'dashboards-all-vulnerabilities',
		path: `${APP_PREFIX_PATH}/dashboards/all-vulnerabilities`,
		component: React.lazy(() =>
			import('views/app-views/dashboards/all-vulnerabilities')
		),
	}] : []),
	// ...(modulePermissions?.includes("DETECTED") ? [{
	// 	key: 'dashboards-cve-details',
	// 	path: `${APP_PREFIX_PATH}/dashboards/cve/cve-details/:id`,
	// 	component: React.lazy(() =>
	// 		import('views/app-views/dashboards/cve-details')
	// 	),
	// }]: []),
	// {
	// 	key: 'dashboards-cve-name',
	// 	path: `${APP_PREFIX_PATH}/dashboards/cve/detected-vulnerability-name/:id`,
	// 	component: React.lazy(() =>
	// 		import('views/app-views/dashboards/dejected-vulnerability-name')
	// 	),
	// },
	// {
	// 	key: 'dashboards-detected-vulnerability-table',
	// 	path: `${APP_PREFIX_PATH}/dashboards/cve/vulnerability-table/:id`,
	// 	component: React.lazy(() =>
	// 		import('views/app-views/dashboards/cve/components/DetectedVulnerabilityTable')
	// 	),
	// },
	// {
	// 	key: 'dashboards-cve-version',
	// 	path: `${APP_PREFIX_PATH}/dashboards/cve/detected-vulnerability-version/:id`,
	// 	component: React.lazy(() =>
	// 		import('views/app-views/dashboards/dejected-vulnerability-version')
	// 	),
	// },
	// ...(modulePermissions?.includes("WEBSITE_SECURITY_SCANNER") ? [{
	// 	key: 'apps-website-security-checker',
	// 	path: `${APP_PREFIX_PATH}/apps/website-security-checker`,
	// 	component: React.lazy(() => import('views/app-views/dashboards/url-security-checker')),
	// }] : []),
	...(modulePermissions?.includes("SCRUM_BOARD") ? [{
		key: 'dashboards-scrumboard-board',
		path: `${APP_PREFIX_PATH}/dashboards/scrumboard/board`,
		component: React.lazy(() =>
			import('views/app-views/dashboards/scrumboard')
		),
	}] : []),
	...(modulePermissions?.includes("PERFORMANCE_TESTS") ? [{
		key: 'dashboards-performance-test',
		path: `${APP_PREFIX_PATH}/dashboards/performance/performance-test`,
		component: React.lazy(() =>
			import('views/app-views/dashboards/performance')
		),
	}] : []),
	...(modulePermissions?.includes("PERFORMANCE_TESTS") ? [{
		key: 'dashboards-performance-test-result',
		path: `${APP_PREFIX_PATH}/dashboards/performance/performance-test-result`,
		component: React.lazy(() =>
			import('views/app-views/dashboards/performancetestresult')
		),
	}] : []),
	...(modulePermissions?.includes("PERFORMANCE_TESTS") ? [{
		key: 'dashboards-performance-ssl-result',
		path: `${APP_PREFIX_PATH}/dashboards/performance/performance-ssl-result`,
		component: React.lazy(() =>
			import('views/app-views/dashboards/ssl-analysis-result')
		),
	}] : []),
	...(modulePermissions?.includes("PERFORMANCE_TESTS") ? [{
		key: 'dashboards-performance-ssl-analysis-result',
		path: `${APP_PREFIX_PATH}/dashboards/performance/performance-ssl-analysis-result/:id`,
		component: React.lazy(() =>
			import('views/app-views/dashboards/ssl-reports')
		),
	}] : []),
	// {
	// 	key: 'dashboards-social-scan',
	// 	path: `${APP_PREFIX_PATH}/dashboards/social/scan`,
	// 	component: React.lazy(() =>
	// 		import('views/app-views/dashboards/socialScan')
	// 	),
	// },
	// ...(modulePermissions?.includes("SOCIAL_MEDIA") ? [{
	// 	key: 'dashboards-social-select',
	// 	path: `${APP_PREFIX_PATH}/dashboards/social/scan/select`,
	// 	component: React.lazy(() =>
	// 		import('views/app-views/dashboards/socialScanSelect')
	// 	),
	// }]: []),
	// ...(modulePermissions?.includes("SOCIAL_MEDIA") ? [{
	// 	key: 'dashboards-social-results',
	// 	path: `${APP_PREFIX_PATH}/dashboards/social/scan/results`,
	// 	component: React.lazy(() =>
	// 		import('views/app-views/dashboards/socialScanResults')
	// 	),
	// }]: []),
	// {
	// 	key: 'dashboards-ssl-details',
	// 	path: `${APP_PREFIX_PATH}/dashboards/ssl/ssl-details/:id`,
	// 	component: React.lazy(() =>
	// 		import('views/app-views/dashboards/ssl-details')
	// 	),
	// },
	...(modulePermissions?.includes("DEPARTMENT") ? [{
		key: 'apps-user-group',
		path: `${APP_PREFIX_PATH}/apps/user-group/*`,
		component: React.lazy(() => import('views/app-views/dashboards/user-group')),
	}] : []),
	...(modulePermissions?.includes("EMAIL_LEAKAGE") ? [{
		key: 'email-leakage-domains',
		path: `${APP_PREFIX_PATH}/email-leakage/domains`,
		component: React.lazy(() => import('views/app-views/dashboards/email-leakage/domains-page')),
	}] : []),
	...(modulePermissions?.includes("EMAIL_LEAKAGE") ? [{
		key: 'email-leakage-vip',
		path: `${APP_PREFIX_PATH}/email-leakage/vip`,
		component: React.lazy(() => import('views/app-views/dashboards/email-leakage/vip-page')),
	}] : []),
	...(modulePermissions?.includes("EMAIL_LEAKAGE") ? [{
		key: 'email-leakage-domain-detail',
		path: `${APP_PREFIX_PATH}/email-leakage/domains/:name/:id`,
		component: React.lazy(() =>
			import('views/app-views/dashboards/email-leakage/domains')
		),
	}] : []),
	...(modulePermissions?.includes("EMAIL_LEAKAGE") ? [{
		key: 'email-leakage-detail',
		path: `${APP_PREFIX_PATH}/email-leakage/details/:id`,
		component: React.lazy(() =>
			import('views/app-views/dashboards/email-leakage/details')
		),
	}] : []),
	...(modulePermissions?.includes("FRAUD_DETECTION") ? [{
		key: 'apps-fraud-detection',
		path: `${APP_PREFIX_PATH}/fraud-detection/frauds`,
		component: React.lazy(() => import('views/app-views/dashboards/fraud-detection')),
	}] : []),
	...(modulePermissions?.includes("FRAUD_DETECTION") ? [{
		key: 'apps-fraud-takedown-operations',
		path: `${APP_PREFIX_PATH}/fraud-detection/fraud-takedown-operations`,
		component: React.lazy(() => import('views/app-views/dashboards/fraud-takedown-operations')),
	}] : []),
	...(modulePermissions?.includes("FRAUD_DETECTION") ? [{
		key: 'apps-fraud-details',
		path: `${APP_PREFIX_PATH}/fraud-detection/fraud-details/:id`,
		component: React.lazy(() => import('views/app-views/dashboards/fraud-details')),
	}] : []),
    ...([{
        key: 'darkweb-dashboard',
        path: `${APP_PREFIX_PATH}/darkweb`,
        component: React.lazy(() => import('views/app-views/dashboards/darkweb/dashboard')),
    }, {
        key: 'darkweb-last-leaks',
        path: `${APP_PREFIX_PATH}/darkweb/last-leaks`,
        component: React.lazy(() => import('views/app-views/dashboards/darkweb/last-leaks')),
    }, {
        key: 'darkweb-lookalike-domains',
        path: `${APP_PREFIX_PATH}/darkweb/lookalike-domains`,
        component: React.lazy(() => import('views/app-views/dashboards/darkweb/lookalike-domains')),
    }, {
        key: 'darkweb-database-leaks',
        path: `${APP_PREFIX_PATH}/darkweb/database-leaks`,
        component: React.lazy(() => import('views/app-views/dashboards/darkweb/third-party-leaks')),
    }]),
	...(modulePermissions?.includes("THREAT_INTELLIGENCE") ? [{
		key: 'apps-threat-intelligence',
		path: `${APP_PREFIX_PATH}/threat-intelligence/dashboard`,
		component: React.lazy(() => import('views/app-views/dashboards/open-cti/pages/Dashboard')),
	}] : []),
	...([{
		key: 'apps-threat-intelligence-cve-dashboard',
		path: `${APP_PREFIX_PATH}/threat-intelligence/cve-dashboard`,
		component: React.lazy(() => import('views/app-views/dashboards/open-cti/pages/CveDashboard')),
	}]),
	...([{
		key: 'apps-threat-intelligence-cve-detail',
		path: `${APP_PREFIX_PATH}/threat-intelligence/cve/:cveId`,
		component: React.lazy(() => import('views/app-views/dashboards/open-cti/pages/CveDetailPage')),
	}]),
	// ...(modulePermissions?.includes("NEWS") ? [{
	// 	key: 'news',
	// 	path: `${APP_PREFIX_PATH}/news`,
	// 	component: React.lazy(() => import('views/app-views/dashboards/news')),
	// }]: []),
	...(modulePermissions?.includes("CODE")
		? [
			{
				key: 'my-codes',
				path: `${APP_PREFIX_PATH}/code/my-codes`,
				component: React.lazy(() => import('views/app-views/dashboards/code')),
			},
			{
				key: 'code-detail',
				path: `${APP_PREFIX_PATH}/code/code-detail`,
				component: React.lazy(() => import('../views/app-views/dashboards/code-detail')),
			},
			{
				key: 'code-statistics',
				path: `${APP_PREFIX_PATH}/code/code-statistics`,
				component: React.lazy(() => import('../views/app-views/dashboards/code-statistics')),
			},
		]
		: []),
	{
		key: 'settings',
		path: `${APP_PREFIX_PATH}/settings`,
		component: React.lazy(() => import('views/app-views/dashboards/settings-page')),
	},
	{
		key: 'help',
		path: `${APP_PREFIX_PATH}/help`,
		component: React.lazy(() => import('views/app-views/dashboards/help-page')),
	},
	{
		key: 'apps-chat',
		path: `${APP_PREFIX_PATH}/apps/chat`,
		component: React.lazy(() => import('views/app-views/dashboards/agent-chat-page')),
	},
	{
		key: 'error-fallback',
		path: `${APP_PREFIX_PATH}/error-fallback`,
		component: React.lazy(() => import('views/app-views/dashboards/error-fallback')),
	},
	// {
	// 	key: 'dashboards-port-versions',
	// 	path: `${APP_PREFIX_PATH}/dashboards/port-versions/:name`,
	// 	component: React.lazy(() =>
	// 		import('views/app-views/dashboards/port-versions')
	// 	),
	// },
];

export const panelRoutes = [
	{
		key: 'dashboard',
		path: `/panel/dashboard`,
		component: React.lazy(() => import('../panel/pages/dashboard-page')),
	},
	{
		key: 'accounts',
		path: `/panel/accounts`,
		component: React.lazy(() => import('../panel/pages/accounts-page')),
	},
	{
		key: 'account-settings',
		path: '/panel/account-settings',
		component: React.lazy(() => import('../panel/pages/accounts-settings-page')),
	},
	{
		key: 'demo-requests',
		path: `/panel/demo-requests`,
		component: React.lazy(() => import('../panel/pages/demo-requests-page')),
	},
	{
		key: 'asset-counts',
		path: `/panel/asset-counts`,
		component: React.lazy(() => import('../panel/pages/asset-counts-page')),
	},
	{
		key: 'module-usage',
		path: `/panel/module-usage`,
		component: React.lazy(() => import('../panel/pages/module-usage-page')),
	},
	{
		key: 'scan-permissions',
		path: `/panel/scan-permissions`,
		component: React.lazy(() => import('../panel/pages/scan-permissions-page')),
	},
	{
		key: 'takedown-requests',
		path: `/panel/takedown-requests`,
		component: React.lazy(() => import('../panel/pages/takedown-requests-page')),
	},
	{
		key: 'easm-form',
		path: `/panel/easm-form`,
		component: React.lazy(() => import('../panel/pages/easm-form-page')),
	},
	{
		key: 'dehashed-data-wells',
		path: `/panel/dehashed-data-wells`,
		component: React.lazy(() => import('../panel/pages/dehashed-data-wells-page')),
	},
	{
		key: 'user-login-history',
		path: `/panel/user-login-history`,
		component: React.lazy(() => import('../panel/pages/user-login-history-page')),
	},
	{
		key: 'tickets',
		path: `/panel/tickets`,
		component: React.lazy(() => import('../panel/pages/tickets-page')),
	},
	{
		key: 'parameters',
		path: `/panel/parameters`,
		component: React.lazy(() => import('../panel/pages/parameters-page')),
	},
	{
		key: 'queues',
		path: `/panel/queues`,
		component: React.lazy(() => import('../panel/pages/queues-page')),
	},
	{
		key: 'clear-cache',
		path: `/panel/clear-cache`,
		component: React.lazy(() => import('../panel/pages/clear-cache-page')),
	},
];

